import React from "react";   
import ProductCampAnyListPageContainer from "./ProductCampAnyListPageContainer";
export class ProductCampAnyListPage extends React.Component {
  render() {
    return <ProductCampAnyListPageContainer {...this.props} />;
  }
}
